import React from 'react';
import styles from '../styles/auth_demo.scss';
import {UnderConstruction} from "./portfolio/projects/UnderConstruction";


export const AuthDemo = props => {
    return (
        <div className={styles.container}>
            <UnderConstruction/>
            {/*<div className={styles.loginContainer}>*/}
            {/*    <div className={styles.textArea}>You are logged out.</div>*/}
            {/*    <div className={styles.button}>Login with Google</div>*/}
            {/*</div>*/}
        </div>
    )
};
